import { addDays, DisplayDate } from 'owa-datetime';

export default function friendlyEndDateForAllDay(end: DisplayDate): DisplayDate {
    // If the item is allDay we have to remove one day form the end date so it displays correctly to the user
    // A one day event is saved with start: May 18 and end: May 19, but
    // the start and end displayed to the user are start: May 18 and end: May 18
    return addDays(end, -1);
}
